import { render, staticRenderFns } from "./ChangeCalendarResponsible.vue?vue&type=template&id=6aad9606&"
import script from "./ChangeCalendarResponsible.vue?vue&type=script&lang=js&"
export * from "./ChangeCalendarResponsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports